const OwnershipList={
  Growth:1,
  International:2,
  Value:3
}
export default OwnershipList;
